<template>
  <div v-if="isExternal">
    <button @click="backToCabinet" class="secondary-button nav-back-button">
      <span>Вернуться в мой кабинет</span>
    </button>
    <div class="admin-logout-icon" tabindex="3" @click="backToCabinet">
      <LogoutOutlined />
    </div>
  </div>
</template>

<script>
import { useStore } from "vuex";
import { computed } from "@vue/runtime-core";
import { LogoutOutlined } from "@ant-design/icons-vue";

export default {
  name: "back-cabinet-btn",
  components: { LogoutOutlined },
  setup() {
    const store = useStore(),
      isExternal = computed(() =>
        store.state.user && store.state.user.externalEnter
          ? store.state.user.externalEnter
          : false
      );
    const backToCabinet = () => {
      let mainToken = document.cookie.match(
        new RegExp("ei-token-main=([^;]*)")
      );
      if (mainToken) {
        store.commit("setUser", {
          token: `Bearer ${mainToken[1]}`,
        });
        window.location.href = `${process.env.VUE_APP_BACK}/auth/main`;
      }
    };

    return {
      backToCabinet,
      isExternal,
    };
  },
};
</script>

<style lang="scss" scoped>
  .nav-back-button {
    font-size: 12px;
    color: var(--main-font);
    margin-right: 12px;
    background-color: #FFFFFF;
    padding: 3px 5px;
    border-radius: 6px;
    border: 1px solid #d9d9d9;

    @media (max-width: $mobile-breakpoint) {
      display: none;
    }
  }

  .admin-logout-icon {
    display: none;
    margin-right: 12px;
    color: var(--main-font);
    cursor: pointer;
    transition: opacity 0.4s ease;

    @media (max-width: $mobile-breakpoint) {
      display: block;
    }

    &:hover {
      opacity: 0.7;
    }
  }
</style>